import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { toast } from "sonner";
import { api, formatApiError } from "@/lib/api";
import { SEO } from "@/lib/seo";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";

export default function AdminLogin() {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      await api.post("/auth/login", { email, password });
      toast.success("Welcome back.");
      navigate("/admin");
    } catch (err) {
      toast.error(formatApiError(err));
    } finally {
      setLoading(false);
    }
  };

  return (
    <div data-testid="admin-login-page" className="min-h-screen bg-navy text-cream flex items-center justify-center px-6 grain relative">
      <div className="relative z-10 w-full max-w-md">
        <p className="font-serif text-4xl font-medium text-center">Vitaliah <span className="italic text-gold">Admin</span></p>
        <form data-testid="admin-login-form" onSubmit={submit} className="mt-12 space-y-6 bg-navy-light border border-navy-border p-10">
          <div>
            <Label htmlFor="al-email" className="text-xs uppercase tracking-[0.2em] text-cream/50">Email</Label>
            <Input id="al-email" data-testid="admin-email-input" type="email" required value={email} onChange={(e) => setEmail(e.target.value)} className="mt-2 rounded-none bg-navy border-navy-border text-cream px-4 py-6 focus-visible:ring-gold" />
          </div>
          <div>
            <Label htmlFor="al-password" className="text-xs uppercase tracking-[0.2em] text-cream/50">Password</Label>
            <Input id="al-password" data-testid="admin-password-input" type="password" required value={password} onChange={(e) => setPassword(e.target.value)} className="mt-2 rounded-none bg-navy border-navy-border text-cream px-4 py-6 focus-visible:ring-gold" />
          </div>
          <button data-testid="admin-login-submit" type="submit" disabled={loading} className="w-full bg-gold text-navy py-4 text-sm font-semibold tracking-wide hover:bg-cream transition-colors duration-300 disabled:opacity-60">
            {loading ? "Signing in..." : "Sign In"}
          </button>
        </form>
      </div>
    </div>
  );
}
